import { toast } from "react-toastify";
import { isValidAadhar, isValidEmail, isValidMobile, isValidPan, isValidPassword } from "./Validations";
import { returnCamelText } from "./FilterationFunctions";

export const showSwal = (
  errorTitle,
  errorMessage,
  status,
  navigateCallback
) => {
  const isSuccess = status >= 200 && status < 300;
  const message = errorMessage || errorTitle || (isSuccess ? "Success" : "Error");

  // Show toast notification
  if (isSuccess) {
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  // Handle navigation callback
  if (navigateCallback) {
    setTimeout(() => {
      navigateCallback();
    }, isSuccess ? 3000 : 1000);
  }

  // Handle token expiration
  if (errorMessage == "Invalid token or expired") {
    setTimeout(() => {
      window.location.href = '/loginPage'
    }, 1000);
  }
};

/**
 * Handle rate limit errors (429 Too Many Requests)
 * Shows a user-friendly message with retry information
 */
export const showRateLimitError = (errorData) => {
  const { message, retryAfter, limit, window } = errorData;

  // Format retry time
  let retryMessage = "";
  if (retryAfter) {
    const minutes = Math.floor(retryAfter / 60);
    const seconds = retryAfter % 60;

    if (minutes > 0) {
      retryMessage = `Please try again in ${minutes} minute${minutes > 1 ? 's' : ''}${seconds > 0 ? ` and ${seconds} second${seconds > 1 ? 's' : ''}` : ''}.`;
    } else {
      retryMessage = `Please try again in ${seconds} second${seconds > 1 ? 's' : ''}.`;
    }
  }

  // Build the full message
  let fullMessage = message || "Too many requests, please try again later.";

  if (limit && window) {
    fullMessage += `\n\nLimit: ${limit} requests per ${window}`;
  }

  if (retryMessage) {
    fullMessage += `\n\n${retryMessage}`;
  }

  // Show error toast with longer duration for rate limits
  toast.error(fullMessage, {
    position: "top-right",
    autoClose: Math.min(retryAfter ? retryAfter * 1000 : 10000, 15000), // Show for up to 15 seconds or retryAfter time
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const handleRegisterInputChange = (
  field,
  value,
  setRegisterDetails,
  setRegisterDetailsErr,
  currentOption,
  allOptions
) => {
  switch (field) {
    case "fname":
      setRegisterDetails((prevDetails) => {
        let lastName = prevDetails.name.split(" ")[1];
        return {
          ...prevDetails,
          name: value + " " + lastName,
        };
      });
      break;
    case "lname":
      setRegisterDetails((prevDetails) => {
        let firstName = prevDetails.name.split(" ")[0];
        return {
          ...prevDetails,
          name: firstName + " " + value,
        };
      });
      break;
    case "mobile_no":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        mobile_no: parseInt(value),
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        mobile_no: isValidMobile(value),
      }));
      break;
    case "email":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        email: value,
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        email: isValidEmail(value),
      }));
      break;
    case "aadhar_no":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        aadhar_no: value,
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        aadhar_no: isValidAadhar(value),
      }));
      break;
    case "pan_no":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        pan_no: value,
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        pan_no: isValidPan(value),
      }));
      break;
    case "password":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        [field]: value,
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        [field]: isValidPassword(value),
      }));
      break;
    case "confirm_password":
    case "confirmPassword":
      let password
      setRegisterDetails((prevDetails) => {
        password = prevDetails.password
        return {
          ...prevDetails,
          [field]: value,
        }
      });
      setRegisterDetailsErr((prevDetails) => {
        return {
          ...prevDetails,
          [field]:
            password === value ? "" : "Password does not match",
        };
      });
      break;
    case "reg_u_name":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        [field]: value,
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        [field]: value == "" ? "User Name Cannot Be Empty" : value.length > 4 || !/^[A-Z]+$/.test(value) ? "User Name must be 4 characters long and all uppercase alphabets only" : "",
      }));
      break;
    case "role":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        role: value == role.admin ? role.admin : role.user,
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        confirmPassword:
          prevDetails.password === value ? "" : "Password does not match",
      }));
      break;
    case "content_intrest":
    case "platforms":
      const updatedValue = value
        ? [...allOptions, currentOption]
        : allOptions.filter((item) => item !== currentOption);
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        [field]: updatedValue,
      }));
      setRegisterDetailsErr((prevErrors) => ({
        ...prevErrors,
        [field]: updatedValue.length == 0 ? returnCamelText(field) + " Cannot Be Empty, Select Atleast One" : "",
      }));
      break;
    case "content":
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        [field]: value,
      }));
      setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        [field]: currentOption
      }));
      break;
    default:
      setRegisterDetails((prevDetails) => ({
        ...prevDetails,
        [field]: value,
      }));
      setRegisterDetailsErr && setRegisterDetailsErr((prevDetails) => ({
        ...prevDetails,
        [field]: value == "" ? " Cannot Be Empty" : "",
      }));
      break;
  }
};